import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import styles from './AdViseStep10.module.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { isMobile } from 'react-device-detect';
import api from '../../../api';
import { copyToClipboard, josa, openInstagramMedia } from '../../../util';

const AdViseStep10 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
  const isProdDomain = window.location.hostname === 'app.hotple.today';
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [resources, setResources] = useState([]);
  const [usedResource, setUsedResource] = useState([]);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    async function loadResources() {
      try {
        const resp = await api.get('/advise/admin/fileInfo', {
          params: { name: stepProps[8].fileName }
        });
        const matched = Array.isArray(resp.data)
          ? resp.data.find(f => f.name === stepProps[8].fileName)
          : resp.data;

        setResources(matched?.resources || []);
        setUsedResource(matched?.used_resource || []);

        // --- 여기가 추가된 부분 ---
        const urls = matched?.contents_url || [];
        // 각각 fetch → blob → objectURL
        const downloaded = await Promise.all(
          urls.filter(url => !(url.includes('instagram.jpg') || url.includes('facebook.jpg'))).map(async (url) => {
            const bustUrl = `${url}${url.includes('?') ? '&' : '?'}_=${Date.now()}`;
            const r = await fetch(bustUrl, { cache: 'no-store' });
            const blob = await r.blob();
            return {
              url: URL.createObjectURL(blob),
              isVideo: blob.type.startsWith('video/')
            };
          })
        );
        setFiles(downloaded);
        // -----------------------
      } catch (err) {
        console.error('리소스 정보 가져오기 실패:', err);
      }
    }
    loadResources();

    // 컴포넌트 언마운트 시에 생성한 ObjectURL 해제
    return () => {
      files.forEach(URL.revokeObjectURL);
    };
  }, [stepProps[8].fileName]);

  const handleResourceStatusChange = async (authorName, newStatus) => {
    const resourceIds = [];

    resources.forEach(res => {
      if(res.author_name==authorName)
        resourceIds.push(res.id);
    });

    resourceIds.forEach(resId => {
      patchResourceStatusChange(resId, newStatus);
    });
  }

  const patchResourceStatusChange = async (resourceId, newStatus) => {
    try {
      const { data: updated } = await api.patch(
        `/advise/admin/resource/${resourceId}/status`,
        { status: newStatus }
      );
      setResources(rs => {
       const updatedResources = rs.map(r =>
         r.id === resourceId ? { ...r, status: updated.status } : r
       );

       // 2) resourceStatus 맵 재계산
       const statusMap = {
         '승인 필요': 'before',
         '승인 대기': 'pending',
         '승인 완료': 'approve',
         '승인 거절': 'denied',
       };
       const resourceStatus = updatedResources.reduce((acc, r) => {
         const key = statusMap[r.status];
         if (key) acc[key].push(r.author_name);
         return acc;
       }, { before: [], pending: [], approve: [], denied: [] });

       // 3) stepProps[10].resourceStatus 업데이트
       setStepProps(prev => {
         const next = [...prev];
         next[10] = {
           ...next[10],
           resourceStatus
         };
         return next;
       });

       return updatedResources;
     });
    } catch (err) {
      console.error('리소스 상태 변경 실패:', err);
      alert('상태 변경에 실패했습니다.');
    }
  };

  const settings = {
    infinite: false,
    speed: 200,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
  };

  const whenHomeButtonClicked = () => {
    const confirmHome = window.confirm(
      "첫 화면으로 돌아가면 편집 결과가 사라집니다.\n\n정말 돌아가시겠습니까?"
    );
    if (confirmHome) {
      setAdViseStep(0);
    }
  };

  const whenBlogClicked = (status, url, authorName) => {
    const comment = `안녕하세요 ${authorName}님😊 저는 지역별 핫플레이스를 매일 한 장소씩 소개해주는 HOTPLE 인스타/페북 운영자입니다!

이번에 저희 팔로워 분들께 [${stepProps[3].hotple.name}]${josa(stepProps[3].hotple.name,'을를')} 소개드리구 싶어서 찾아보던 중에 예쁘게 잘 찍어주신 사진이 눈에 띄더라구요ㅎㅎ

혹시 ${stepProps[3].hotple.name}${josa(stepProps[3].hotple.name,'을를')} 소개할 때 ${authorName}님께서 찍어주신 사진을 함께 보여드려도 괜찮을지 여쭤봐도 될까요? (물론, 출처도 이미지 위에 꼭꼭 표기할게요!)

괜찮으시다면 ‘좋아요’나 짧게 '답글' 남겨주시면 정말 감사드리겠습니다🙇‍♀️

오늘도 기분 좋은 하루 보내세요💛`

    copyToClipboard(comment);
    window.open(url, '_blank');

    if(status=='승인 필요')
      handleResourceStatusChange(authorName, '승인 대기')
  };

  const saveFiles = async (isTestUpload = false) => {
    // stepProps에서 필요한 값들 꺼내오기
    const {
      adviseId,
      comment,
      needComment,
      needInstagramUpload,
      needPageUpload,
      needOfficialUpload
    } = stepProps[10];
    const targetRegion = stepProps[1];

    // 1) 업로드할 플랫폼이 하나도 선택되지 않았으면 종료
    if (!needInstagramUpload && !needPageUpload) {
      alert('업로드할 플랫폼이 선택되지 않았습니다!');
      return;
    }

    // 2) 처음에 정말 업로드할지 확인
    const modeLabel = isTestUpload ? '테스트' : targetRegion;
    const platformsLabel = [
      needPageUpload     ? '[페이스북]'    : '',
      needInstagramUpload ? '[인스타그램]' : ''
    ].filter(Boolean).join(' ');
    if (!window.confirm(`정말 이 프로젝트를 [${modeLabel}]의 ${platformsLabel} 계정에 업로드 할까요?`)) {
      return;
    }

    setIsUploading(true);

    try {
      // 4) 백엔드에 업로드 요청
      const { data: advise } = await api.post('/advise/admin/upload', {
        adviseId,
        comment,
        needComment,
        needInstagramUpload,
        needPageUpload,
        needOfficialUpload,
        isTestUpload
      });

      // 5) 응답에서 instagram_media / facebook_media 배열 꺼내기
      const igList = Array.isArray(advise.instagram_media) ? advise.instagram_media : [];
      const fbList = Array.isArray(advise.facebook_media) ? advise.facebook_media : [];

      // 6) 성공 여부 판정
      const igOk = needInstagramUpload
        ? igList.some(item =>
            (isTestUpload || targetRegion=='테스트')
              ? item.region === '테스트'           // 테스트 모드면 '테스트' region 존재 여부
              : item.region !== '테스트'           // 실제 모드면 '테스트' 아닌 region 존재 여부
          )
        : true;

      const fbOk = needPageUpload
        ? fbList.some(item =>
            (isTestUpload || targetRegion=='테스트')
              ? item.region === '테스트'
              : item.region !== '테스트'
          )
        : true;
      const success = igOk && fbOk;

      // 8) 실패 시에는 alert, 어떤 플랫폼이 실패했는지 안내
      if (!success) {
        const failedPlatforms = [];
        if (needInstagramUpload && !igOk) failedPlatforms.push('인스타그램');
        if (needPageUpload     && !fbOk) failedPlatforms.push('페이스북');

        alert(
          `${failedPlatforms.join(', ')} 업로드에 실패했습니다.\n` +
          '관리자 페이지에서 오류를 확인해주세요.'
        );
        return; // 페이지 유지
      }

      // 9) 성공 메시지 구성 (전지역인지 여부에 따라 텍스트만 다름)
      let msg = targetRegion === '전지역' && !isTestUpload
        ? '전지역 업로드가 순차적으로 요청되었으며 첫 지역 업로드에 성공하였습니다.\n*모든 지역 계정에 업로드 되기까지 약 10분~20분 정도 소요되며, 업로드 완료/실패 시 메시지가 전송됩니다.'
        : '업로드에 성공했습니다!';
      msg += '\n\n업로드 된 게시글을 확인하러 가시겠습니까?';

      // 10) confirm → user action 으로 묶인 window.open 호출
      if (window.confirm(msg)) {
        // 1) 열어야 할 URL 리스트 준비
        const openIg = needInstagramUpload
          ? igList.filter(item =>
              (isTestUpload || targetRegion=='테스트')
                ? item.region === '테스트'
                : item.region !== '테스트'
            )
          : [];
        const openFb = needPageUpload
          ? fbList.filter(item =>
              (isTestUpload || targetRegion=='테스트')
                ? item.region === '테스트'
                : item.region !== '테스트'
            )
          : [];

        // 2) 각 플랫폼별로 첫 번째 항목만 꺼내서 열기
        const igToOpen = openIg[0];
        const fbToOpen = openFb[0];

        // 3) 인스타 → 페북 순서로 새 탭 열기
        if (igToOpen) openInstagramMedia(igToOpen.media_url);
        if (fbToOpen) openInstagramMedia(fbToOpen.media_url);
      }

      if (!isTestUpload) {
        setAdViseStep(0);
      }
    } catch (error) {
      console.error('saveFiles error:', error);

      const errCode = error.response?.data?.error;
      if (errCode === 'INVALID_MEDIA_TYPE') {
        // 2207026 에러 대응
        alert('❌ 잘못된 미디어가 포함되어 있습니다.\n지원되지 않거나 손상된 파일을 확인해주세요.');
      } else {
        // 그 외 서버 에러
        alert('업로드 중 서버 오류가 발생했습니다.');
      }
    } finally {
      setIsUploading(false);
    }
  };



  const allUsedApproved =
  usedResource.length === 0 ||
  usedResource.every(id => {
    const res = resources.find(r => r.id === id);
    return res?.status === '승인 완료';
  });
  const canUpload = allUsedApproved && isProdDomain;

  return (
    <div className={styles.outerframe}>
      <div className={styles.upperframe}>
        <img
          className={styles.backbuttonIcon}
          alt="뒤로"
          src="images/back_android.svg"
          onClick={() => setAdViseStep(9)}
        />
        <div className={styles.titleframe}>
          <b className={styles.nextbuttontext}>업로드 미리보기</b>
          <div className={styles.stepdesc}>이대로 [{stepProps[1]}] 계정에 업로드 할까요?</div>
        </div>
        <img
          className={styles.homebuttonIcon}
          alt="홈"
          src="images/home_outlined.svg"
          onClick={whenHomeButtonClicked}
        />
      </div>

      <div
        className={styles.lowerframe}
        style={{ height: `calc(100dvh - ${marginTop}px - 103px - 74px)` }}
      >
        {files.length === 0 ? (
          <div className={styles.loadingFrame}>
            <div className={styles.loader} />
            <div className={styles.stepdesc}>편집된 결과가 없습니다.</div>
          </div>
        ) : (
            <div className={styles.contentframe}>
                <div className={styles.contiframe}>
                    <div className={styles.conticontentframe}>
                        {!isMobile &&
                          <div className={styles.pagebutton} onClick={() => sliderRef.current?.slickPrev()}>
                              <div className={styles.pagebuttontext}>◀</div>
                          </div>
                        }

                        <div className={styles.imageframe} style={{height: isMobile ? `calc(100vw / (${stepProps[8].ratio}))` : `calc(420px / (${stepProps[8].ratio}))`}}>
                            <Slider
                                ref={sliderRef}
                                {...settings}
                                className={styles.previewSlider}
                                style={{height: isMobile ? `calc(100vw / (${stepProps[8].ratio}))` : `calc(420px / (${stepProps[8].ratio}))`}}
                            >
                                {files.map((file, idx) =>
                                file.isVideo ? (
                                    <video
                                      key={idx}
                                      src={file.url}
                                      autoPlay
                                      loop
                                      muted
                                      playsInline
                                      className={styles.media}
                                    />
                                  ) : (
                                    <img
                                      key={idx}
                                      src={file.url}
                                      alt={`preview-${idx}`}
                                      className={styles.media}
                                    />
                                  )
                                )}
                                {stepProps[8].addLastPromotionPage &&
                                  <img
                                    src='https://hotple.s3.ap-northeast-2.amazonaws.com/advise/last_page/instagram.jpg'
                                    className={styles.media}
                                    />
                                }
                            </Slider>

                            <div className={styles.pageframe}>
                                <div className={styles.pagetext}>{currentSlide + 1} / {stepProps[8].addLastPromotionPage ? files.length +1 : files.length}</div>
                            </div>
                        </div>

                        {!isMobile &&
                          <div className={styles.pagebutton} onClick={() => sliderRef.current?.slickNext()}>
                              <div className={styles.pagebuttontext}>▶</div>
                          </div>
                        }
                    </div>
                </div>
                <div className={styles.contentframe}>
                    <div className={styles.placeframe}>
                        <div className={styles.placeresulttext}>
                            {stepProps[9].caption
                                .split(/(#[^\s#]+)/g)               // 해시태그 부분을 캡처 그룹으로 분리
                                .map((part, idx) =>
                                    part.match(/^#[^\s#]+$/) ? (     // #으로 시작하고 공백/다른 #이 없는 부분만
                                        <span key={idx} style={{ color: '#4150F7' }}>
                                        {part}
                                        </span>
                                    ) : (
                                        part
                                    )
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.checkboxFrame}>
                  <div className={styles.placetitle}>인스타그램 업로드</div>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={stepProps[10].needInstagramUpload}
                    onChange=
                      {e => setStepProps(prev => {
                            const newProps = [...prev];
                            newProps[10] = {...newProps[10], needInstagramUpload: e.target.checked}
                            return newProps;
                        })
                      }
                  />
                  <div className={styles.padding}/>
                  <div className={styles.placetitle}>페이스북 업로드</div>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={stepProps[10].needPageUpload}
                    onChange=
                      {e => setStepProps(prev => {
                            const newProps = [...prev];
                            newProps[10] = {...newProps[10], needPageUpload: e.target.checked}
                            return newProps;
                        })
                      }
                  />
                </div>

                <div className={styles.checkboxFrame}>
                  <div className={styles.placetitle}>첫 댓글 설정</div>
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={stepProps[10].needComment}
                    onChange=
                      {e => setStepProps(prev => {
                            const newProps = [...prev];
                            newProps[10] = {...newProps[10], needComment: e.target.checked}
                            return newProps;
                        })
                      }
                  />

                  <div className={styles.padding}/>

                  {stepProps[1] == '전지역' &&
                    <>
                      <div className={styles.placetitle}>공식 계정 업로드</div>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={stepProps[10].needOfficialUpload}
                        onChange=
                          {e => setStepProps(prev => {
                                const newProps = [...prev];
                                newProps[10] = {...newProps[10], needOfficialUpload: e.target.checked}
                                return newProps;
                            })
                          }
                      />
                    </>
                  }
                </div>

                {stepProps[10].needComment &&
                  <div className={styles.placeframe2}>
                      <textarea
                          className={styles.placeresulttext2}
                          value={stepProps[10].comment}
                          onChange={e => {
                              setStepProps(prev => {
                                  const newProps = [...prev];
                                  newProps[10] = {...newProps[10], comment: e.target.value}
                                  return newProps;
                              });
                              e.target.style.height = 'auto';
                              e.target.style.height = e.target.scrollHeight + 'px';
                          }}
                          ref={el => {
                                if (el) {
                                    el.style.height = 'auto';
                                    el.style.height = el.scrollHeight + 'px';
                                }
                              }}
                          rows={Math.max(stepProps[10].comment.split('\n').length, 2)}
                      />
                  </div>
                }

                {resources.length > 0 && (
                  <div className={styles.resourcesFrame}>
                    <div className={styles.resourcesTitle}>리소스<br/>상태</div>
                    {[...resources]
                      // used_resource에 포함된 순서대로 앞으로
                      .sort((a, b) => {
                        const aUsed = usedResource.includes(a.id);
                        const bUsed = usedResource.includes(b.id);
                        if (aUsed === bUsed) return 0;
                        return aUsed ? -1 : 1;
                      })
                      .map(res => {
                        const statusClass = (() => {
                          switch (res.status) {
                            case '승인 필요': return styles.needs;
                            case '승인 대기': return styles.pending;
                            case '승인 완료': return styles.approved;
                            case '승인 거절': return styles.deny;
                            default: return '';
                          }
                        })();
                        const isUsed = usedResource.includes(res.id);
                        return (
                          <div
                            key={res.id}
                            className={isUsed ? styles.resourceRowUsed : styles.resourceRow}
                          >
                            <div
                              onClick={() => whenBlogClicked(res.status, res.url, res.author_name)}
                              className={`${styles.resourceLink} ${statusClass}`}
                            >
                              {res.author_name}
                            </div>
                            <select
                              className={`${styles.ratioSelect} ${statusClass}`}
                              value={res.status}
                              onChange={e => handleResourceStatusChange(res.author_name, e.target.value)}
                            >
                              <option value="승인 필요">승인 필요</option>
                              <option value="승인 대기">승인 대기</option>
                              <option value="승인 완료">승인 완료</option>
                              <option value="승인 거절">승인 거절</option>
                            </select>
                          </div>
                        );
                      })}
                  </div>
                )}
            </div>
          )}
      </div>

      <div className={styles.nextbuttonframe}>
        <div className={styles.backbutton2} onClick={()=>saveFiles(true)}>
            <div className={styles.nextbuttontext2}>테스트 업로드</div>
        </div>
        <div
          className={canUpload ? styles.nextbutton : styles.nextbuttonDisabled}
          onClick={() => {
            if (!canUpload) return;
            saveFiles();
          }}
        >
          <b className={styles.nextbuttontext1}>
            {allUsedApproved ? '업로드하기 →' : '리소스 승인 필요'}
          </b>
        </div>
      </div>

      {isUploading &&
        <div className={styles.loadingFrame}>
          <div className={styles.loader}/>
          <div className={styles.loadingText}>
            업로드 중...
          </div>
        </div>
      }
    </div>
  );
};

export default AdViseStep10;